import { SitelifeFile } from './types';
import { CreateModelFileResponse, ForgeProgressStatus } from './types';
import { BulkProjectFilesRequest, BulkProjectFilesResponse } from './types';
import { api } from 'src/common/fetch';

export async function getProjectFiles(projectId: string) {
  return api.get<SitelifeFile[]>(`/api/projects/${projectId}/files`);
}

export async function getProjectFiles2(projectId: string) {
  return api.get<SitelifeFile[]>(
    `/api/projects/${projectId}/files/getProjectFiles2`,
  );
}

export async function createModelFile(projectId: string, fileData: any) {
  return api.post<CreateModelFileResponse>(
    `/api/projects/${projectId}/files`,
    fileData,
  );
}

export async function deleteFile(projectId: string, fileId: string) {
  return api.delete(`/api/projects/${projectId}/files/${fileId}`);
}

export async function refreshForgeStatus(
  projectId: string,
  fileId: string,
  versionId: string,
) {
  return api.post<ForgeProgressStatus>(
    `/api/forge/derivative/projects/${projectId}/files/${fileId}/versions/${versionId}/refresh-status`,
  );
}

export async function triggerForgeTranslation(
  projectId: string,
  fileId: string,
  versionId: string,
) {
  return api.post(
    `/api/forge/derivative/projects/${projectId}/files/${fileId}/versions/${versionId}`,
  );
}

export async function completeBatchSignedS3Upload(
  projectId: string,
  uploadKey: string,
  objectKey: string,
) {
  return api.post(`/api/projects/${projectId}/files/batchcompleteupload`, {
    uploadKey,
    objectKey,
  });
}

/**
 * Fetches files for multiple projects in a single request.
 *
 * @param projectIds - Array of project IDs to fetch files for
 * @returns Promise resolving to an array of responses, each containing projectId and files
 *
 * @example
 * ```typescript
 * const projectIds = ["project1_id", "project2_id", "project3_id"];
 * const results = await getMultipleProjectFiles2(projectIds);
 *
 * // Results structure:
 * // [
 * //   { projectId: "project1_id", files: [...] },
 * //   { projectId: "project2_id", files: [...] },
 * //   { projectId: "project3_id", files: [] }
 * // ]
 * ```
 */
export async function getMultipleProjectFiles2(projectIds: string[]) {
  const requestBody: BulkProjectFilesRequest = {
    projectIds,
  };

  return api.post<BulkProjectFilesResponse>(
    '/api/projects/bulk/files/getMultipleProjectFiles2',
    requestBody,
  );
}
